/* eslint-disable camelcase */
// import dateFormat from 'dateformat';
import moment from 'moment';
import { Colors } from '../../../themes/colors';
import { formatNumber } from '../../../utils/NumberUtils';

import Level0 from '../../../images/properks_levels/level0.svg';
import Level1 from '../../../images/properks_levels/level1.svg';
import Level2 from '../../../images/properks_levels/level2.svg';
import Level3 from '../../../images/properks_levels/level3.svg';
import { states } from '../../commonComponents/StatePicker';

const styles = {
  tableText: {
    fontWeight: '400',
    fontSize: '13px',
    fontFamily: 'Nunito',
    color: Colors.neutral_600,
    textAlign: 'center',
  },
  baseIconStyle: {
    marginRight: -13,
    width: 40,
    height: 42,
  },
};

export const formatDateRange = (row = {}) => {
  const { date_start, date_end } = row;
  const now = moment();
  const dateStart =
    moment(date_start).year() === now.year()
      ? moment(date_start).format('MM/DD')
      : moment(date_start).format('YYYY/MM/DD');
  const dateEnd =
    moment(date_end).year() === now.year()
      ? moment(date_end).format('MM/DD')
      : moment(date_end).format('YYYY/MM/DD');

  return `${dateStart} - ${dateEnd}`;
};

export const handleActiveRow = (row = {}) => {
  const { date_end, is_cancelled } = row;
  const now = moment();

  if (!date_end || is_cancelled) return false;

  const end = moment(date_end).endOf('day');

  return now.isSameOrBefore(end);
};

export const handleInactiveRow = (row = {}) => !handleActiveRow(row);

export const properksChallengeColumn = ({ onRelaunch, onCancel }) => [
  {
    selector: (row) => row.name,
    name: 'Challenge Name',
    style: styles.tableText,
    format: (row) => row.name || '-',
    width: '200px',
  },
  {
    selector: (row) => row.type,
    name: 'Challenge',
    format: (row) =>
      row.type && row.completed_count
        ? `${formatNumber(row.completed_count)} ${challengeType?.[row.type] || row.type}`
        : '-',
    style: styles.tableText,
    width: '180px',
  },
  {
    selector: (row) => row.reward,
    name: 'Prize',
    format: (row) => (row.reward ? `${formatNumber(row.reward)} Points` : '-'),
    width: '110px',
  },
  {
    selector: (row) => row.date_start,
    name: 'Date Range',
    cell: (row) => (
      <div style={{ ...styles.tableText, display: 'flex', textAlign: 'left' }}>
        {(row.date_start && row.date_end ? `${formatDateRange(row)}` : '-')}
      </div>
    ),
    style: styles.tableText,
    width: '150px',
  },
  {
    selector: (row) => row.professions,
    name: 'Profession Type',
    style: styles.tableText,
    format: (row) => row?.professions?.join?.(', ') || '-',
    width: '150px',
  },
  {
    selector: (row) => row.levels,
    name: 'Level(s)',
    format: (row) => row?.levels?.map?.((item) => item) || '-',
    width: '160px',
    cell: (row) => (
      <div style={{ ...styles.tableText, display: 'flex' }}>
        {row.levels.map((item) => {
          switch (item) {
            case 0:
              return (
                <img src={Level0} alt="level0" style={{ ...styles.baseIconStyle, zIndex: 4 }} />
              );
            case 1:
              return (
                <img src={Level1} alt="level1" style={{ ...styles.baseIconStyle, zIndex: 3 }} />
              );
            case 2:
              return (
                <img src={Level2} alt="level2" style={{ ...styles.baseIconStyle, zIndex: 2 }} />
              );
            case 3:
              return (
                <img src={Level3} alt="level3" style={{ ...styles.baseIconStyle, zIndex: 1 }} />
              );

            default:
              return null;
          }
        })}
      </div>
    ),
  },
  {
    selector: (row) => row.states,
    name: 'State',
    style: styles.tableText,
    cell: (row) => (
      <div style={{ ...styles.tableText, display: 'flex', textAlign: 'left' }}>
        {row.states.length === states.length ? 'All' : row.states?.join?.(', ')}
      </div>
    ),
    width: '100px',
  },
  {
    selector: (row) => row.created_by,
    name: 'Admin',
    style: styles.tableText,
    format: (row) => row.created_by || '-',
    width: '200px',
  },
  {
    selector: (row) => row.admin,
    style: styles.tableText,
    name: ' ',
    cell: (row) => {
      const isChallengeStarted = moment().isSameOrAfter(moment(row.date_start));
      return (
        <div style={{ ...styles.tableText, display: 'flex', gap: 10 }}>
          <button className="btn btn-info" type="button" onClick={() => onRelaunch(row)}>
            Relaunch
          </button>
          {!isChallengeStarted && !row.is_cancelled && (
            <button className="btn btn-danger" type="button" onClick={() => onCancel(row.id)}>
              Cancel
            </button>
          )}
        </div>
      );
    },
  },
];

export const properksChallengeConditionalRowStyles = [
  {
    when: (row) => handleActiveRow(row),
    style: {
      backgroundColor: Colors.background_60,
    },
  },
  {
    when: (row) => handleInactiveRow(row),
    style: {
      backgroundColor: Colors.neutral_50,
    },
  },
];

export const challengeType = {
  job_completed: 'Complete Shift',
  referral_completed: 'Complete Referrals',
  application_submitted: 'Submit Applications',
};

export const All = 'all';

export const challengeStatusFilter = {
  all: All,
  active: 'active',
  inactive: 'inactive',
};
